<template>
  <div
    :class="{
      'pb-row': true,
      direction,
      fullHeight,
      [`justify-${justify}`]: true,
      [`align-${align}`]: true,
    }"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "PbRow",
  props: {
    direction: Boolean,
    align: {
      type: String, // "center" | "flex-end" | "flex-start",
      default: () => "flex-start",
    },
    justify: {
      type: String, // "center" | "flex-end" | "flex-start" | "space-between" | "space-around",
      default: () => "flex-start",
    },
    fullHeight: Boolean,
  },
  methods: {},
};
</script>
<style lang="scss">
@import "~styles/size";

.pb-row {
  display: flex;
  width: 100%;

  & + .pb-row {
    margin-top: 16px;
  }

  &.direction {
    flex-direction: column;
  }

  &.fullHeight {
    height: 100%;
  }

  &.justify {
    &-flex-start {
      justify-content: flex-start;
    }

    &-flex-end {
      justify-content: flex-end;
    }

    &-center {
      justify-content: center;
    }

    &-space-around {
      justify-content: space-around;
    }

    &-space-between {
      justify-content: space-between;
    }
  }

  &.align {
    &-flex-start {
      align-items: flex-start;
    }

    &-flex-end {
      align-items: flex-end;
    }

    &-center {
      align-items: center;
    }
  }
}

@media (max-width: $min_layout) {
  .pb-row {
    flex-direction: column;
  }
}
</style>
